import { render, staticRenderFns } from "./ItemCardSalesData.vue?vue&type=template&id=f5155492&scoped=true"
import script from "./ItemCardSalesData.vue?vue&type=script&lang=ts"
export * from "./ItemCardSalesData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5155492",
  null
  
)

export default component.exports